export const PRODUCT_LOADING = 'PRODUCT_LOADING';
export const PRODUCTS_FULFILLED = 'PRODUCTS_FULFILLED';
export const PRODUCT_FULFILLED = 'PRODUCT_FULFILLED';
export const PRODUCT_STOCK_AUDIT_FULFILLED = 'PRODUCT_STOCK_AUDIT_FULFILLED';
export const PRODUCT_STOCK_UPDATED = 'PRODUCT_STOCK_UPDATED';
